import React, { useEffect, useState } from "react";
import { Button, MenuSelect } from "./Form";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsRight,
  FiEdit,
  FiEye,
} from "react-icons/fi";
import { RiDeleteBin6Line, RiDeleteBinLine } from "react-icons/ri";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { IoCloudUploadOutline } from "react-icons/io5";

const thclass = "text-start text-sm font-medium py-3 px-1 whitespace-nowrap";
const tdclass = "text-start text-sm py-4 px-1 whitespace-nowrap";

export function Transactiontable({ data, action, functions }) {
  const DropDown1 = [
    {
      title: "Edit",
      icon: FiEdit,
      onClick: (data) => {
        functions.edit(data.id);
      },
    },
    {
      title: "View",
      icon: FiEye,
      onClick: (data) => {
        functions.preview(data.id);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>#</th>
          <th className={thclass}>Patient</th>
          <th className={thclass}>Date</th>
          <th className={thclass}>Status</th>
          <th className={thclass}>
            Amout <span className="text-xs font-light">(Tsh)</span>
          </th>
          <th className={thclass}>Method</th>
          {action && <th className={thclass}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>{index + 1}</td>
            <td className={tdclass}>
              <div className="flex gap-4 items-center">
                <span className="w-12">
                  <img
                    src={item.user.image}
                    alt={item.user.title}
                    className="w-full h-12 rounded-full object-cover border border-border"
                  />
                </span>

                <div>
                  <h4 className="text-sm font-medium">{item.user.title}</h4>
                  <p className="text-xs mt-1 text-textGray">
                    {item.user.phone}
                  </p>
                </div>
              </div>
            </td>
            <td className={tdclass}>{item.date}</td>
            <td className={tdclass}>
              <span
                className={`py-1 px-4 ${
                  item.status === "Paid"
                    ? "bg-subMain text-subMain"
                    : item.status === "Pending"
                    ? "bg-orange-500 text-orange-500"
                    : item.status === "Cancel" && "bg-red-600 text-red-600"
                } bg-opacity-10 text-xs rounded-xl`}
              >
                {item.status}
              </span>
            </td>
            <td className={`${tdclass} font-semibold`}>{item.amount}</td>
            <td className={tdclass}>{item.method}</td>
            {action && (
              <td className={tdclass}>
                <MenuSelect datas={DropDown1} item={item}>
                  <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                    <BiDotsHorizontalRounded />
                  </div>
                </MenuSelect>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// invoice table
export function InvoiceTable({ data }) {
  const navigate = useNavigate();
  const DropDown1 = [
    {
      title: "Edit",
      icon: FiEdit,
      onClick: (item) => {
        navigate(`/invoices/edit/${item.id}`);
      },
    },
    {
      title: "View",
      icon: FiEye,
      onClick: (item) => {
        navigate(`/invoices/preview/${item.id}`);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Invoice ID</th>
          <th className={thclass}>Patient</th>
          <th className={thclass}>Created Date</th>
          <th className={thclass}>Due Date</th>
          <th className={thclass}>
            Amout <span className="text-xs font-light">(Tsh)</span>
          </th>
          <th className={thclass}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>#{item?.id}</td>
            <td className={tdclass}>
              <div className="flex gap-4 items-center">
                <span className="w-12">
                  <img
                    src={item?.to?.image}
                    alt={item?.to?.title}
                    className="w-full h-12 rounded-full object-cover border border-border"
                  />
                </span>
                <div>
                  <h4 className="text-sm font-medium">{item?.to?.title}</h4>
                  <p className="text-xs mt-1 text-textGray">
                    {item?.to?.email}
                  </p>
                </div>
              </div>
            </td>
            <td className={tdclass}>{item?.createdDate}</td>
            <td className={tdclass}>{item?.dueDate}</td>
            <td className={`${tdclass} font-semibold`}>{item?.total}</td>
            <td className={tdclass}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// prescription table
export function MedicineTable({ data, onEdit }) {
  const DropDown1 = [
    {
      title: "Edit",
      icon: FiEdit,
      onClick: (item) => {
        onEdit(item);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Name</th>
          <th className={thclass}>
            Price <span className="text-xs font-light">(Tsh)</span>
          </th>
          <th className={thclass}>Status</th>
          <th className={thclass}>InStock</th>
          <th className={thclass}>Measure</th>
          <th className={thclass}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>
              <h4 className="text-sm font-medium">{item?.name}</h4>
            </td>
            <td className={`${tdclass} font-semibold`}>{item?.price}</td>
            <td className={tdclass}>
              <span
                className={`text-xs font-medium ${
                  item?.status === "Out of stock"
                    ? "text-red-600"
                    : "text-green-600"
                }`}
              >
                {item?.status}
              </span>
            </td>
            <td className={tdclass}>{item?.stock}</td>
            <td className={tdclass}>{item?.measure}</td>
            <td className={tdclass}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// service table

export function ServiceTable({ data, onEdit, onSave }) {
  const [operatorSelections, setOperatorSelections] = useState({});

  useEffect(() => {
    const initialSelections = {};
    data.forEach((service) => {
      initialSelections[service._id] = new Set(
        service.operator?.map((op) => op._id) || []
      );
    });
    setOperatorSelections(initialSelections);
  }, [data]);

  const handleCheckboxChange = (serviceId, operatorId, checked) => {
    setOperatorSelections((prev) => {
      const updated = new Set(prev[serviceId]);
      checked ? updated.add(operatorId) : updated.delete(operatorId);
      return { ...prev, [serviceId]: updated };
    });
  };

  const isUnchecked = (serviceId, operatorId) => {
    return !operatorSelections[serviceId]?.has(operatorId);
  };

  const handleSave = () => {
    const payload = Object.entries(operatorSelections).map(
      ([serviceId, storeSet]) => ({
        serviceId,
        operator: Array.from(storeSet),
      })
    );
    onSave(payload); // 👈 pass to parent
  };

  return (
    <div>
      <div className="text-right mt-4">
        <button
          onClick={handleSave}
          className="w-60 mb-12 flex items-center justify-center gap-4 hover:opacity-80 transitions bg-subMain text-border text-sm font-medium px-2 py-4 rounded"
        >
          Update Services{" "}
          <IoCloudUploadOutline className="text-border text-xl" />
        </button>
      </div>
      <table className="table-auto w-full">
        <thead className="bg-dry rounded-md overflow-hidden text-text border-b border-yellowlight">
          <tr>
            <th className={thclass}>Name ({data.length})</th>
            <th className={thclass}>Category</th>
            <th className={thclass}>Price</th>
            <th className={thclass}>Time</th>
            <th className={thclass}>Store</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item._id} className="border-b border-border text-text">
              <td className={tdclass}>
                <h4 className="text-sm font-medium">{item.title}</h4>
              </td>
              <td className={tdclass}>{item.category}</td>
              <td className={`${tdclass} font-semibold`}>{item.price}</td>
              <td className={tdclass}>{item.desc}</td>
              <td className={tdclass}>
                <ul className="space-y-1 text-xs">
                  {item.operator?.map((op) => (
                    <li key={op._id} className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={!isUnchecked(item._id, op._id)}
                        onChange={(e) =>
                          handleCheckboxChange(
                            item._id,
                            op._id,
                            e.target.checked
                          )
                        }
                        className="form-checkbox accent-yellowlight"
                      />
                      <span
                        className={`font-medium ${
                          isUnchecked(item._id, op._id)
                            ? "line-through text-border"
                            : ""
                        }`}
                      >
                        {op.name} <span className="italic">({op.address})</span>
                      </span>
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// export function ServiceTable({ data, onEdit }) {
//   // console.log({ data });
//   const DropDown1 = [
//     {
//       title: "View",
//       icon: FiEdit,
//       onClick: (item) => {
//         onEdit(item);
//       },
//     },
//   ];

//   const totalServices = data?.length || 0;

//   const uniqueCategories = new Set(data?.map((item) => item.category));
//   const totalCategories = uniqueCategories.size;

//   const [uncheckedStores, setUncheckedStores] = useState({});

//   const handleCheckboxChange = (serviceId, storeId, checked) => {
//     setUncheckedStores((prev) => {
//       const key = `${serviceId}-${storeId}`;
//       const newState = { ...prev };

//       if (!checked) {
//         newState[key] = true;
//       } else {
//         delete newState[key];
//       }

//       return newState;
//     });
//   };

//   const isCrossedOut = (serviceId, storeId) => {
//     return uncheckedStores[`${serviceId}-${storeId}`];
//   };

//   return (
//     <table className="table-auto w-full">
//       <thead className="bg-dry rounded-md overflow-hidden text-text border-b border-yellowlight">
//         <tr>
//           <th className={thclass}>Name ({totalServices})</th>
//           <th className={thclass}>Category ({totalCategories}) </th>
//           <th className={thclass}>
//             Price <span className="text-xs font-light">($nz)</span>
//           </th>
//           <th className={thclass}>Time</th>
//           <th className={thclass}>Store</th> {/* ✅ New column */}
//           <th className={thclass}>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {data?.map((item) => (
//           <tr
//             key={item._id}
//             className="border-b border-border hover:bg-greyed transitions text-text hover:text-dry"
//           >
//             <td className={tdclass}>
//               <h4 className="text-sm font-medium">{item?.title}</h4>
//             </td>
//             <td className={tdclass}>{item?.category}</td>
//             <td className={`${tdclass} font-semibold`}>{item?.price}</td>
//             <td className={tdclass}>
//               <span
//                 className={`text-xs font-medium ${
//                   !item?.desc ? "text-red-600" : "text-green-600"
//                 }`}
//               >
//                 {item?.desc}
//               </span>
//             </td>
//             <td className={tdclass}>
//               {item?.operator?.length > 0 ? (
//                 <ul className="space-y-1 text-xs">
//                   {item.operator.map((op) => {
//                     const crossed = isCrossedOut(item._id, op._id);

//                     return (
//                       <li key={op._id} className="flex items-center gap-1">
//                         <input
//                           type="checkbox"
//                           defaultChecked
//                           onChange={(e) =>
//                             handleCheckboxChange(
//                               item._id,
//                               op._id,
//                               e.target.checked
//                             )
//                           }
//                           className="form-checkbox accent-yellowlight"
//                           id={`checkbox-${item._id}-${op._id}`}
//                         />
//                         <label
//                           htmlFor={`checkbox-${item._id}-${op._id}`}
//                           className={`cursor-pointer ${
//                             crossed ? "line-through text-subMain" : ""
//                           }`}
//                         >
//                           <span className="font-medium">{op.name}</span>
//                           <span className="ml-1 italic">({op.town})</span>
//                         </label>
//                       </li>
//                     );
//                   })}
//                 </ul>
//               ) : (
//                 <span className="text-xs text-subMain italic">No operator</span>
//               )}
//             </td>
//           </tr>
//         ))}
//       </tbody>
//     </table>
//   );
// }

// patient table
export function PatientTable({ data, functions, used }) {
  const DropDown1 = !used
    ? [
        {
          title: "View",
          icon: FiEye,
          onClick: (data) => {
            functions.preview(data._id);
          },
        },
        {
          title: "Delete",
          icon: RiDeleteBin6Line,
          onClick: (data) => {
            functions.delete(data._id, data.name);
          },
          // onClick: () => {
          //   toast.error("This feature is not available yet");
          // },
        },
      ]
    : [
        {
          title: "View",
          icon: FiEye,
          onClick: (data) => {
            functions.preview(data.id);
          },
        },
      ];
  const thclasse =
    "text-start text-sm font-medium py-3 px-2 whitespace-nowrap text-text";
  const tdclasse = "text-start text-xs py-4 px-2 whitespace-nowrap text-text";

  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclasse}>#</th>
          <th className={thclasse}>Staff</th>
          <th className={thclasse}>Email</th>
          <th className={thclasse}>Created At</th>

          <th className={thclasse}>Services</th>
          <th className={thclasse}>Timeslot</th>

          {/* {!used && (
            <>
              <th className={thclasse}>Blood Group</th>
              <th className={thclasse}>Age</th>
            </>
          )} */}

          <th className={thclasse}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-yellowlight transitions"
          >
            <td className={tdclasse}>{index + 1}</td>
            <td className={tdclasse}>
              <div className="flex gap-4 items-center">
                {!used && (
                  <span className="w-12">
                    <img
                      src={item.photo}
                      alt={item.title}
                      className="w-full h-12 rounded-full object-cover border border-border"
                    />
                  </span>
                )}

                <div>
                  <h4 className="text-sm font-medium text-yellowdark">
                    {item.name}
                  </h4>
                  {/* <p className="text-xs mt-1 text-textGray">+64 {item.phone}</p> */}
                </div>
              </div>
            </td>
            <td className={tdclasse}>
              <span
                className={`py-1 px-4 ${
                  item.gender === "Male"
                    ? "bg-subMain text-subMain"
                    : "bg-orange-500 text-orange-500"
                } bg-opacity-10 text-xs rounded-xl`}
              >
                {item.email}
              </span>
            </td>
            <td className={tdclasse}>
              {new Date(item.updatedAt).toLocaleString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </td>

            {!used && (
              <>
                <td className={tdclasse}>
                  <div>
                    <p className="text-xs text-textGray">
                      Nails:{" "}
                      <span className="text-yellowdark">
                        {item.nailService?.length || 0}
                      </span>
                    </p>
                    <p className="text-xs mt-1 text-textGray">
                      Beauty:
                      <span className="text-yellowdark">
                        {item.beautyService?.length || 0}
                      </span>
                    </p>
                  </div>
                </td>
                <td className={tdclasse}>
                  {" "}
                  {item.timeslot?.map((slot, index) => (
                    <p key={index}>
                      {slot.day}{" "}
                      <span className="text-yellowdark">
                        ({slot.slots?.length || 0})
                      </span>
                      {index !== item.timeslot.length - 1 && ", "}
                    </p>
                  ))}
                </td>
              </>
            )}

            <td className={tdclasse}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className="bg-dry border border-border text-text text-xl py-2 px-4 rounded-lg">
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// doctor table
export function DoctorsTable({ data, functions, doctor }) {
  const DropDown1 = [
    {
      title: "View",
      icon: FiEye,
      onClick: (data) => {
        functions.preview(data);
      },
    },
    {
      title: "Delete",
      icon: RiDeleteBin6Line,
      onClick: () => {
        toast.error("This feature is not available yet");
      },
    },
  ];
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>#</th>
          <th className={thclass}>{doctor ? "Doctor" : "Receptionist"}</th>
          <th className={thclass}>Created At</th>
          <th className={thclass}>Phone</th>
          <th className={thclass}>Title</th>
          <th className={thclass}>Email</th>
          <th className={thclass}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>{index + 1}</td>
            <td className={tdclass}>
              <div className="flex gap-4 items-center">
                <span className="w-12">
                  <img
                    src={item.user.image}
                    alt={item.user.title}
                    className="w-full h-12 rounded-full object-cover border border-border"
                  />
                </span>
                <h4 className="text-sm font-medium">{item.user.title}</h4>
              </div>
            </td>
            <td className={tdclass}>12 May, 2021</td>
            <td className={tdclass}>
              <p className="text-textGray">{item.user.phone}</p>
            </td>
            <td className={tdclass}>{item.title}</td>
            <td className={tdclass}>{item.user.email}</td>

            <td className={tdclass}>
              <MenuSelect datas={DropDown1} item={item}>
                <div className="bg-dry border text-main text-xl py-2 px-4 rounded-lg">
                  <BiDotsHorizontalRounded />
                </div>
              </MenuSelect>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// appointment table
export function AppointmentTable({ data, functions, doctor }) {
  const ITEMS_PER_PAGE = 7;
  const [currentPage, setCurrentPage] = useState(1);
  // Pagination logic
  const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const sortedData = [...data].sort(
    (a, b) =>
      dayjs(b.selectedDateTime, "YYYY-MM-DD hh:mm A").valueOf() -
      dayjs(a.selectedDateTime, "YYYY-MM-DD hh:mm A").valueOf()
  );

  const currentData = sortedData.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  const sortedDates = data
    .map((item) => dayjs(item.selectedDateTime, "YYYY-MM-DD hh:mm A"))
    .sort((a, b) => a - b);

  const startDate = sortedDates[0]?.format("DD MMM YYYY") || "-";
  const endDate =
    sortedDates[sortedDates.length - 1]?.format("DD MMM YYYY") || "-";
  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-subMain">
          Total Bookings: {data.length}
        </h2>
        <p className="text-xs text-textGray">
          From <span className="font-medium">{startDate}</span> to{" "}
          <span className="font-medium">{endDate}</span>
        </p>
      </div>

      {/* Table */}
      <table className="table-auto w-full border-t border-b border-yellowlight">
        <thead className="bg-drylight rounded-md overflow-hidden text-yellowlight border-b border-yellowlight">
          <tr>
            <th className={thclass}>Date</th>
            <th className={thclass}>Customer</th>
            <th className={thclass}>Status</th>
            <th className={thclass}>Time</th>
            <th className={thclass}>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentData.map((item) => {
            const date = dayjs(
              item.selectedDateTime,
              "YYYY-MM-DD hh:mm A"
            ).format("DD MMM YYYY");
            const time = dayjs(
              item.selectedDateTime,
              "YYYY-MM-DD hh:mm A"
            ).format("hh:mm A");

            return (
              <tr
                key={item._id}
                className="border-b border-border text-text hover:bg-textGray transitions"
              >
                <td className={tdclass}>
                  <p className="text-xs">{date}</p>
                </td>

                <td className={tdclass}>
                  <h4 className="text-xs font-medium">
                    {item.customer_info?.name ||
                      item.user?.displayName ||
                      "N/A"}
                  </h4>
                  <p className="text-xs mt-1 text-textGray">
                    {item.customer_info?.mobile || item.user?.phone}
                  </p>
                </td>

                <td className={tdclass}>
                  {(() => {
                    const bookingDateTime = dayjs(
                      item.selectedDateTime,
                      "YYYY-MM-DD hh:mm A"
                    );
                    const isPast = bookingDateTime.isBefore(dayjs());
                    const status = isPast
                      ? "Completed"
                      : item.booking?.status || "booked";

                    const statusClass =
                      status === "Approved"
                        ? "bg-subMain text-subMain"
                        : status === "Pending"
                        ? "bg-orange-500 text-orange-500"
                        : status === "Cancel"
                        ? "bg-red-600 text-red-600"
                        : status === "Completed"
                        ? "bg-orange-500 text-orange-500"
                        : "bg-green-600 text-green-600";

                    return (
                      <span
                        className={`py-1 px-4 ${statusClass} bg-opacity-10 text-xs rounded-xl`}
                      >
                        {status}
                      </span>
                    );
                  })()}
                </td>

                <td className={tdclass}>
                  <p className="text-xs">{time}</p>
                </td>

                <td className={tdclass}>
                  <button
                    onClick={() => functions.preview(item)}
                    className="text-sm flex-colo bg-dry text-subMain border border-subMain rounded-md w-10 h-10"
                  >
                    <FiEye />
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="flex justify-end gap-4 py-4">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className={`p-2 rounded-md  ${
            currentPage === 1 ? "text-gray-400" : "text-yellowlight"
          }`}
        >
          <FiChevronLeft className="text-lg" />
        </button>

        <span className="text-sm mt-1 text-text">
          Page {currentPage} of {totalPages}
        </span>

        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
          className={`p-2 rounded-md  ${
            currentPage === totalPages ? "text-gray-400" : "text-yellowlight"
          }`}
        >
          <FiChevronRight className="text-lg" />
        </button>
      </div>
    </div>
  );
}

//customer table
export function CustomersTable({ data, functions, doctor }) {
  // Group bookings by user.id
  const grouped = data.reduce((acc, booking) => {
    const userId = booking.user?.id;
    if (!userId) return acc;

    if (!acc[userId]) {
      acc[userId] = {
        user: booking.user,
        bookings: [],
      };
    }

    acc[userId].bookings.push(booking);
    return acc;
  }, {});

  const groupedData = Object.values(grouped);
  const totalCustomers = groupedData.length;

  // Flatten all booking dates to get range
  const allDates = data
    .map((item) => dayjs(item.selectedDateTime, "YYYY-MM-DD hh:mm A"))
    .sort((a, b) => a - b);

  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (isNaN(d)) return "-"; // Invalid date
    return new Intl.DateTimeFormat("en-NZ", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(d);
  };

  const startDate = formatDate(allDates[0]);
  const endDate = formatDate(allDates[allDates.length - 1]);

  return (
    <div className="space-y-4">
      {/* Header summary */}
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold text-subMain">
          Total Customers: {totalCustomers}
        </h2>
        <p className="text-xs text-textGray">
          From <span className="font-medium">{startDate}</span> to{" "}
          <span className="font-medium">{endDate}</span>
        </p>
      </div>

      {/* Table */}
      <table className="table-auto w-full border-b border-subMain">
        <thead className="bg-dry text-subMain rounded-md overflow-hidden border-t border-b border-subMain">
          <tr>
            <th className={thclass}>Customer</th>
            <th className={thclass}>Bookings</th>
            <th className={thclass}>Action</th>
          </tr>
        </thead>
        <tbody>
          {groupedData.map(({ user, bookings }) => (
            <tr
              key={user.id}
              className="border-b border-border hover:bg-greyed transitions"
            >
              <td className={tdclass}>
                <div className="flex items-center gap-3">
                  <img
                    src={user.photo}
                    alt={user.displayName}
                    className="w-10 h-10 rounded-full object-cover border border-gray-300"
                  />
                  <div className="flex flex-col">
                    <h4 className="text-sm font-semibold text-subMain uppercase">
                      {user.displayName || "N/A"}
                    </h4>
                    <p className="text-xs text-text">{user.username}</p>
                    <p className="text-xs text-text">{user.phone}</p>
                  </div>
                </div>
              </td>

              <td className={tdclass}>
                <p className="text-xs font-semibold text-text">
                  <span className="font-semibold text-yellowlight">
                    {" "}
                    {bookings.length}
                  </span>{" "}
                  booking{bookings.length > 1 ? "s" : ""}
                </p>
              </td>
              {console.log({ user })}
              {console.log({ bookings })}

              <td className={tdclass}>
                <button
                  onClick={() =>
                    functions.preview({
                      userId: user.id,
                      bookingIds: bookings.map((b) => b._id),
                    })
                  }
                  className="text-sm flex-colo  text-subMain border border-subMain rounded-md w-10 h-10"
                >
                  <FiEye />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
// payment table
export function PaymentTable({ data, functions, doctor }) {
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Date</th>
          <th className={thclass}>{doctor ? "Patient" : "Doctor"}</th>
          <th className={thclass}>Status</th>
          <th className={thclass}>Amount</th>
          <th className={thclass}>Method</th>
          <th className={thclass}>Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>
              <p className="text-xs">{item.date}</p>
            </td>
            <td className={tdclass}>
              <h4 className="text-xs font-medium">
                {doctor ? item.user.title : item.doctor.title}
              </h4>
              <p className="text-xs mt-1 text-textGray">
                {doctor ? item.user.phone : item.doctor.phone}
              </p>
            </td>
            <td className={tdclass}>
              <span
                className={`py-1  px-4 ${
                  item.status === "Paid"
                    ? "bg-subMain text-subMain"
                    : item.status === "Pending"
                    ? "bg-orange-500 text-orange-500"
                    : item.status === "Cancel" && "bg-red-600 text-red-600"
                } bg-opacity-10 text-xs rounded-xl`}
              >
                {item.status}
              </span>
            </td>
            <td className={tdclass}>
              <p className="text-xs font-semibold">{`$${item.amount}`}</p>
            </td>
            <td className={tdclass}>
              <p className="text-xs">{item.method}</p>
            </td>

            <td className={tdclass}>
              <button
                onClick={() => functions.preview(item.id)}
                className="text-sm flex-colo bg-white text-subMain border rounded-md w-10 h-10"
              >
                <FiEye />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// invoice used table
export function InvoiceUsedTable({ data, functions }) {
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Invoice ID</th>
          <th className={thclass}>Create Date</th>
          <th className={thclass}>Due Date</th>
          <th className={thclass}>Amount</th>
          <th className={thclass}>Action</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclass}>
              <p className="text-xs">#{item.id}</p>
            </td>
            <td className={tdclass}>
              <p className="text-xs">{item.createdDate}</p>
            </td>
            <td className={tdclass}>
              <p className="text-xs">{item.dueDate}</p>
            </td>

            <td className={tdclass}>
              <p className="text-xs font-semibold">{`$${item.total}`}</p>
            </td>

            <td className={tdclass}>
              <button
                onClick={() => functions.preview(item.id)}
                className="text-sm flex-colo bg-white text-subMain border rounded-md w-10 h-10"
              >
                <FiEye />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// invoice table
export function InvoiceProductsTable({ data, functions, button }) {
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclass}>Item</th>
          <th className={thclass}>
            Item Price
            <span className="text-xs font-light ml-1">(Tsh)</span>
          </th>
          <th className={thclass}>Quantity</th>
          <th className={thclass}>
            Amout
            <span className="text-xs font-light ml-1">(Tsh)</span>
          </th>
          {button && <th className={thclass}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {data?.map((item) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={`${tdclass}  font-medium`}>{item.name}</td>
            <td className={`${tdclass} text-xs`}>{item.price}</td>
            <td className={tdclass}>{item.id}</td>
            <td className={tdclass}>{item.price * item.id}</td>
            {button && (
              <td className={tdclass}>
                <button
                  onClick={() => functions.deleteItem(item.id)}
                  className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                >
                  <RiDeleteBinLine />
                </button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// medicine Dosage table

export function MedicineDosageTable({ data, functions, button }) {
  const thclasse = "text-start text-xs font-medium py-3 px-2 whitespace-nowrap";
  const tdclasse = "text-start text-xs py-4 px-2 whitespace-nowrap";
  return (
    <table className="table-auto w-full">
      <thead className="bg-dry rounded-md overflow-hidden">
        <tr>
          <th className={thclasse}>Item</th>
          <th className={thclasse}>
            Item Price
            <span className="text-xs font-light ml-1">(Tsh)</span>
          </th>
          <th className={thclasse}>Dosage</th>
          <th className={thclasse}>Instraction</th>
          <th className={thclasse}>Quantity</th>
          <th className={thclasse}>
            Amout
            <span className="text-xs font-light ml-1">(Tsh)</span>
          </th>
          {button && <th className={thclasse}>Actions</th>}
        </tr>
      </thead>
      <tbody>
        {data?.map((item) => (
          <tr
            key={item.id}
            className="border-b border-border hover:bg-greyed transitions"
          >
            <td className={tdclasse}>{item.name}</td>
            <td className={tdclasse}>{item.price}</td>
            <td className={tdclasse}>{item.id} - M/A/E</td>
            <td className={tdclasse}>{item.instraction}</td>
            <td className={tdclasse}>{item.id}</td>
            <td className={tdclasse}>{item.price * item.id}</td>
            {button && (
              <td className={tdclasse}>
                <button
                  onClick={() => functions.delete(item.id)}
                  className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
                >
                  <RiDeleteBinLine />
                </button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
